import { Menu } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import { useRouter } from "next/navigation";
import React, { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { useLang } from "@/hooks/use-lang";

import { useDeleteSession } from "../services/delete-session";

export const QuestionItemMenu = ({ id }: { id: string }) => {
  const router = useRouter();
  const { t } = useLang();
  const { mutate } = useDeleteSession();

  const handleDelete = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    mutate(
      { sessionId: id },
      {
        onSuccess: () => {
          router.refresh();
        },
      }
    );
  };

  return (
    <Menu>
      <div className="relative">
        <Menu.Button onClick={(e) => e.stopPropagation()}>
          <EllipsisVerticalIcon
            width={20}
            height={20}
            className="cursor-pointer text-zinc-500"
          />
        </Menu.Button>
        <Menu.Items className="absolute right-0 top-6 z-10 flex flex-col rounded-lg border bg-white py-2">
          <Menu.Item>
            {({ close }) => (
              <MenuItemWrapper
                onClick={(e) => {
                  handleDelete(e);
                  close();
                }}
              >
                {t.winwingpt.deleteRecord}
              </MenuItemWrapper>
            )}
          </Menu.Item>
        </Menu.Items>
      </div>
    </Menu>
  );
};

const MenuItemWrapper = React.forwardRef<HTMLDivElement, ComponentProps<"div">>(
  (props, ref) => (
    <div
      {...props}
      ref={ref}
      className={twMerge(
        "cursor-pointer whitespace-nowrap px-4 py-2 text-sm text-red-700 hover:bg-sky-50"
      )}
    >
      {props.children}
    </div>
  )
);

MenuItemWrapper.displayName = "MenuItemWrapper";
